import moment from 'moment';

const DATE_RANGE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
const DATE_RANGE_LABEL_FORMAT = 'YYYY/MM/DD';
const DATE_RANGE_SEPARATOR = ' to ';
const SINGLE_DATE_FORMAT = 'YYYY-MM-DD';

export const TODAY = moment().startOf('day');

export const getRangeFromDates = ({ startDate, endDate }) => {
  const startDateValue = moment(startDate).format(DATE_RANGE_FORMAT);
  const startDateLabel = moment(startDate).format(DATE_RANGE_LABEL_FORMAT);

  const endDateValue = moment(endDate).format(DATE_RANGE_FORMAT);
  const endDateLabel = moment(endDate).format(DATE_RANGE_LABEL_FORMAT);

  const value = `${startDateValue}${DATE_RANGE_SEPARATOR}${endDateValue}`;
  const label = `${startDateLabel}${DATE_RANGE_SEPARATOR}${endDateLabel}`;

  return { value, label };
};

export const getSingleDate = date => {
  const label = moment(date).format(SINGLE_DATE_FORMAT);
  return { value: label, label };
};

export const getRangeFromDays = (days, isFuture = false) => {
  if (isFuture) {
    const startDate = moment(TODAY);
    const endDate = moment(TODAY).add(days, 'days');

    return getRangeFromDates({ startDate, endDate });
  }

  const startDate = moment(TODAY).subtract(days, 'days');
  const today = moment(TODAY);
  const yesterday = moment(TODAY).subtract(1, 'day');

  const valueRange = getRangeFromDates({ startDate, endDate: today });
  const labelRange = getRangeFromDates({ startDate, endDate: yesterday });

  return { value: valueRange.value, label: labelRange.label };
};

export const getDaysInPast = (days = 7) => {
  const daysInPast = `${days} days ago for ${days} days`;
  const range = getRangeFromDays(days);
  return {
    value: daysInPast,
    label: range.label
  }
}
export const convertDateRangeToDaysInPast = (dateRangeValue) => {
  const [startDate, endDate] = getDatesFromRange(dateRangeValue);
  const days = diff(startDate, endDate);
  const daysInPastValue = getDaysInPast(days);
  return daysInPastValue;
}

export const getDatesFromRange = range => range.split(DATE_RANGE_SEPARATOR);

export const diff = (date1, date2, units = 'days') => {
  const difference = moment(date1).diff(moment(date2), units);
  return Math.abs(difference);
};

export const formatDateRangeLabel = (range, joiner = 'to') => {
  const [date1, date2] = getDatesFromRange(range);

  if (!range || !date1 || !date2) {
    return '';
  }

  return `${moment(date1).format(DATE_RANGE_LABEL_FORMAT)} ${joiner} ${moment(
    date2
  ).format(DATE_RANGE_LABEL_FORMAT)}`;
};

export const getLabelFromRange = range => {
  if (!range) {
    return '';
  }

  const [date1] = getDatesFromRange(range);
  const startDate = moment(date1);

  const yearDiff = diff(startDate, TODAY, 'years');
  const monthDiff = diff(startDate, TODAY, 'months');
  const weekDiff = diff(startDate, TODAY, 'weeks');
  const dayDiff = diff(startDate, TODAY);

  switch (true) {
    case yearDiff >= 1:
      return yearDiff === 1 ? `Last Year` : `Last ${yearDiff} Years`;

    case weekDiff > 3 && monthDiff >= 1:
      return monthDiff === 1 ? `Last Month` : `Last ${monthDiff} Months`;

    case dayDiff > 13:
      return weekDiff === 1 ? `Last Week` : `Last ${weekDiff} Weeks`;

    default:
      return dayDiff === 1 ? `Last Day` : `Last ${dayDiff} Days`;
  }
};

export const isToday = date => TODAY.isSame(moment(date), 'day');
